const middleware = {}

middleware['loginRedirect'] = require('../middleware/loginRedirect.ts')
middleware['loginRedirect'] = middleware['loginRedirect'].default || middleware['loginRedirect']

middleware['requireLogin'] = require('../middleware/requireLogin.ts')
middleware['requireLogin'] = middleware['requireLogin'].default || middleware['requireLogin']

middleware['requireRegister'] = require('../middleware/requireRegister.ts')
middleware['requireRegister'] = middleware['requireRegister'].default || middleware['requireRegister']

middleware['requireReset'] = require('../middleware/requireReset.ts')
middleware['requireReset'] = middleware['requireReset'].default || middleware['requireReset']

export default middleware
